import { FileUpload } from '@/components/shared/upload/FileUpload';

export default function HomePage() {
  return (
    <main className="flex flex-1 items-center justify-center px-6 py-12">
      <FileUpload />
    </main>
  );
}
